import React from "react";
import ReactDOM from "react-dom";

import { datadogRum } from "@datadog/browser-rum";
import Leanplum from "leanplum-sdk";

import App from "./views/App";
import { getConfig } from "./utils/config";

datadogRum.init({
  applicationId: getConfig("DD_APP_ID"),
  clientToken: getConfig("DD_CLIENT_TOKEN"),
  sampleRate: 100,
  trackInteractions: true,
});

if (getConfig("ENVIRONMENT") === "production") {
  Leanplum.setAppIdForProductionMode(
    `${getConfig("LEANPLUM_APP_ID")}`,
    `${getConfig("LEANPLUM_CLIENT_KEY")}`,
  );
} else {
  Leanplum.setAppIdForDevelopmentMode(
    `${getConfig("LEANPLUM_APP_ID")}`,
    `${getConfig("LEANPLUM_CLIENT_KEY")}`,
  );
}

ReactDOM.render(<App />, document.getElementById("root"));
